import type { TourDefinition } from './types';
import { chatTour } from './chat';
import { contractManagementTour } from './contractManagement';
import { organisationsTour } from './organisations';
import { playbooksTour } from './playbooks';
import { reviewProjectsTour } from './reviewProjects';
import { signingTour } from './signing';
import { templatingTour } from './templating';
import { vaultTour } from './vault';
import { viewsTour } from './views';
import { welcomeTour } from './welcome';

/**
 * All registered tours, in the order they appear in the "Take the tour" menu.
 * Adding a tour = adding a definition file and listing it here — see README.md.
 */
export const tours: TourDefinition[] = [
  welcomeTour,
  chatTour,
  vaultTour,
  contractManagementTour,
  viewsTour,
  signingTour,
  reviewProjectsTour,
  playbooksTour,
  templatingTour,
  organisationsTour,
];

export function getTour(key: string): TourDefinition | undefined {
  return tours.find(tour => tour.key === key);
}

export type { TourDefinition, TourStep, TutorialStatus } from './types';
